module.exports = __webpack_public_path__ + "static/media/opening_01.5acb594a.webp";